import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import api from '../api';
import bgImg from './bg.png';

const { Title } = Typography;

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const onFinish = async (values) => {
    setLoading(true);
    const res = await api.post('/login', values);
    setLoading(false);
    if (res.success) {
      localStorage.setItem('token', res.data.token);
      if (onLogin) onLogin(res.data.user);
      setError('');
      message.success('Login successful!');
      window.location.href = '/dashboard'; // Redirect to dashboard or home
    } else {
      // Show a clear message for wrong credentials
      if (res.message && res.message.toLowerCase().includes('invalid')) {
        setError('Incorrect email or password.');
      } else {
        setError(res.message || 'Login failed');
      }
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(120deg, #232526 0%, #414345 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      backgroundImage: `url(${bgImg}), linear-gradient(120deg, #232526 0%, #414345 100%)`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}>
      <div style={{
        width: 400,
        margin: 32,
        background: '#fff',
        borderRadius: 20,
        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        padding: 40
      }}>
        <Title level={2} style={{ textAlign: 'center', marginBottom: 32 }}>Welcome Back</Title>
        {error && (
          <div style={{ color: '#cf1322', marginBottom: 16, textAlign: 'center', fontWeight: 500 }}>
            {error}
          </div>
        )}
        <Form name="login" onFinish={onFinish} layout="vertical">
          <Form.Item name="email" label="Email address" rules={[{ required: true, message: 'Please input your email!' }]}> 
            <Input prefix={<UserOutlined />} placeholder="Email address" autoComplete="email" size="large" onChange={() => setError('')} />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true, message: 'Please input your password!' }]}> 
            <Input.Password prefix={<LockOutlined />} placeholder="Password" autoComplete="current-password" size="large" onChange={() => setError('')} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large" loading={loading} style={{ background: '#000', border: 'none' }}>
              Login
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login; 